import React from 'react';
import { Stat } from '../../../CommonComponents/OPL/Stat/Stat';
import { StatError } from '../../../CommonComponents/OPL/Stat/Stat.error';
import { StatLoading } from '../../../CommonComponents/OPL/Stat/Stat.loading';
import { usePeriodReturn } from './usePeriodReturn';
import { GrossOfFeeIcon } from '../GrossOfFeeIcon/GrossOfFeeIcon';

export const PeriodReturn = () => {
  const { isFetching, isError, refetch, data } = usePeriodReturn();

  if (isFetching) {
    return <StatLoading />;
  }

  if (isError) {
    return <StatError onRetry={refetch} />;
  }

  if (!data) {
    return null;
  }

  const { label, value } = data;

  const Label = (
    <>
      {label}
      <GrossOfFeeIcon />
    </>
  );

  return <Stat label={Label} value={value || '–'} />;
};
